<template>
  <div class="workbench">
    <!-- 卡片设置 -->
    <div class="set-wrap">
      <div class="left">
        <eui-icon
          icon="eicon-gzt-unselected"
          color="#2587FF"
          font-size="24px"
        />
        <div class="text">我的工作台</div>
      </div>
      <div class="right first-element-introduction flex-all-center">
        <div
          v-if="!showQuickGuidance && showQuickGuidanceEnter"
          class="flex-all-center"
          @mouseenter="mouseenter"
          @mouseleave="mouseleave"
          @click="changeShow"
        >
          <eui-icon
            icon="eicon-peizhiyindao"
            :color="mouseOperate ? '#2587FF' : '#333'"
            font-size="18px"
            style="margin-right: 3px"
          />
          <el-tooltip
            class="item"
            effect="dark"
            content="下次点击可以展开引导"
            placement="bottom"
            :manual="true"
            :value="showTip"
          >
            <eui-btn
              type="text"
              :color="mouseOperate ? '#2587FF' : '#333'"
              class="margin-r20"
              >配置引导</eui-btn
            >
          </el-tooltip>
        </div>

        <div v-show="isLayoutSet" class="set-btn" @click="layoutSet">
          布局设置
        </div>
        <div v-show="!isLayoutSet" class="set-content">
          <div class="text">拖拽卡片更改排序</div>
          <div class="card-set" @click="drawer = true">
            卡片设置
            <i class="el-icon-arrow-down"></i>
          </div>
          <div class="cancel" @click="cancelHandle">取消</div>
          <div class="save" @click="saveHandle">保存</div>
        </div>
      </div>
    </div>

    <!--    配置引导 快速上手-->
    <quick-guidance
      v-if="showQuickGuidance && showQuickGuidanceEnter"
      @changeShow="changeShow"
    />

    <el-drawer
      title="卡片显示设置"
      :visible.sync="drawer"
      :before-close="handleClose"
      append-to-body
      :wrapper-closable="false"
    >
      <div class="cord-content-work">
        <el-checkbox-group v-model="dragListCheck" @change="setCardChange">
          <el-checkbox
            v-for="item of dragSetList"
            :key="item.cardCode"
            :label="item.cardCode"
            :disabled="!item.cardCode"
          >
            {{ item.cardName }}
          </el-checkbox>
        </el-checkbox-group>
      </div>
      <div class="btn-content">
        <el-button class="btn cancel-btn" @click="cancelHandle">取消</el-button>
        <el-button class="btn submit-btn" @click="saveHandle">保存</el-button>
      </div>
    </el-drawer>

    <!-- 卡片 -->
    <draggable v-model="dragList" :disabled="isLayoutSet">
      <transition-group>
        <div v-for="element in dragList" :key="element.cardCode">
          <component
            :is="element.component"
            :is-layout-set="!isLayoutSet"
          ></component>
        </div>
      </transition-group>
    </draggable>
    <Express></Express>
    <div v-show="isShadeShow" ref="shade" class="shade-black">
      <div>
        <div class="an-content">
          <div class="an-center"></div>
        </div>
        <div class="message">拖拽卡片更改排序</div>
        <div class="an-btn">
          <eui-btn @click="handleIKnow()">我知道了</eui-btn>
          <div class="an-time">{{ shadeTime }}s后自动关闭</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Draggable from 'vuedraggable';

import Driver from '../../../../../../public/static/driver/driver.js';
import '../../../../../../public/static/driver/driver.css';

import DataBoard from './components/dataBoard.vue';
import PurchaseBar from './components/purchaseBar.vue';
import SellBar from './components/sellBar.vue';
import BaseConfig from './components/basicConfig.vue';
import Service from './components/service.vue';
import StandardNumber from './components/standardNumber.vue';
import DataBoardS from './components/dataBoardS.vue';
import DataCockpit from './components/dataCockpit.vue';
import Message from './components/message.vue';
import Express from './components/express.vue';
import QuickGuidance from './components/quickGuidance.vue';
import _ from 'lodash';
import Api from '@/modules/projectA/api/user';
import { mapMutations } from 'vuex';
import {
  mallBaseUrl,
  callBackUrl,
  bidSysBaseUrl,
} from '@/modules/projectA/api/urlConfig';

export default {
  name: 'Workbench',
  components: {
    DataBoard,
    PurchaseBar,
    SellBar,
    Draggable,
    BaseConfig,
    Service,
    StandardNumber,
    DataBoardS,
    DataCockpit,
    Message,
    Express,
    QuickGuidance,
  },
  data() {
    return {
      mouseOperate: false,
      showQuickGuidance: true, // 切换快速上手，玩转易专采 展示不展示
      showTip: false,
      showQuickGuidanceEnter: false,
      dragListCheck: [],
      dragListClone: [], // 总的
      dragList: [], // 展示
      dragListBase: [
        {
          cardName: '服务报表',
          cardSort: 1,
          id: 1,
          component: 'StandardNumber',
          isShow: false,
        },
        {
          cardName: '基础配置',
          cardSort: 2,
          id: 2,
          component: 'BaseConfig',
          isShow: false,
        },
        {
          cardName: '采购业务',
          cardSort: 3,
          id: 3,
          component: 'PurchaseBar',
          isShow: false,
        },
        {
          cardName: '销售业务',
          cardSort: 4,
          id: 4,
          component: 'SellBar',
          isShow: false,
        },
        {
          cardName: '数据驾驶舱',
          cardSort: 5,
          id: 5,
          component: 'DataCockpit',
          isShow: false,
        },
        {
          cardName: '销售报表',
          cardSort: 6,
          id: 6,
          component: 'DataBoardS',
          isShow: false,
        },
        {
          cardName: '采购报表',
          cardSort: 7,
          id: 7,
          component: 'DataBoard',
          isShow: false,
        },
        {
          cardName: '留言板',
          cardSort: 8,
          id: 8,
          component: 'Message',
          isShow: false,
        },
        {
          cardName: '物流中心',
          cardSort: 9,
          id: 9,
          component: 'Express',
          isShow: false,
        },
        //
        /* {
          cardName: '综合服务',
          cardSort: 8,
          id: 8,
          component: 'Service',
          isShow: false,
        }, */
      ],
      dragSetList: [],
      isLayoutSet: true,
      drawer: false,

      isShadeShow: false,
      shadeTime: 4,
      timer: null,
    };
  },
  actions: {},

  head() {
    return {};
  },
  watch: {
    dragList: {
      handler(newVal) {
        newVal.forEach((item, index) => {
          item.cardSort = index + 1;
        });
      },
      deep: true,
    },
  },
  mounted() {
    this.getCardList();
    this.getUserCardList();
    this.mainInfoIsAdmin();
    this.queryPurchaseProductRangeSet();
  },
  methods: {
    ...mapMutations(['IS_PROTOCOL']),
    // 采购产品范围
    async queryPurchaseProductRangeSet() {
      const res = await Api.queryPurchaseProductRangeSet();
      if (res.code === '200') {
        this.IS_PROTOCOL(res.data);
      }
    },
    async mainInfoIsAdmin() {
      const userInfo = JSON.parse(localStorage.getItem('USERINFO'));
      if (
        userInfo.purchaseAreaFlag &&
        userInfo.purchaseAreaCompanyId === userInfo.companyId
      ) {
        // 相当于 开通了易专采
        const res = await Api.isPurchaserAdmin();
        if (res.success) {
          this.showQuickGuidanceEnter = res.data || false;
          if (this.showQuickGuidanceEnter) {
            this.memberActionQuery();
          }
        }
      }
    },
    // 查询易专采的组织机构配置
    async memberActionQuery() {
      const res = await Api.memberActionQuery({ action: 'yzcOrg' });
      if (res.success) {
        if (res.data) {
          this.showQuickGuidance = res.data.value === 'show';
        } else {
          // 初始化没值默认展示
          this.showQuickGuidance = true;
        }
      }
    },
    // 更改易专采的组织机构配置  value：show表示显示，hidden表示隐藏
    async memberActionSave(value) {
      const res = await Api.memberActionSave({
        action: 'yzcOrg',
        value: value ? 'show' : 'hidden',
      });
      if (res.success) {
      }
    },
    mouseenter() {
      this.mouseOperate = true;
    },
    mouseleave() {
      this.mouseOperate = false;
    },
    // 切换快速上手，玩转易专采 展示不展示
    changeShow() {
      this.showQuickGuidance = !this.showQuickGuidance;
      this.mouseOperate = false;
      if (!this.showQuickGuidance) {
        this.showTip = true;
      }
      setTimeout(() => {
        this.showTip = false;
      }, 5000);

      this.memberActionSave(this.showQuickGuidance);
    },
    // 获取用户卡片列表 用户展示的
    async getUserCardList() {
      const result = await Api.userCardList();
      // console.log(result, '获取用户卡片列表');
      if (result.code === '200') {
        const { data = [] } = result;
        data.forEach((item) => {
          this.dragListCheck.push(item.cardCode);
          this.dragListBase.forEach((iten) => {
            if (item.cardName === iten.cardName) {
              item.component = iten.component;
              iten.cardCode = item.cardCode;
            }
          });
        });
        this.dragList = [...data];
        this.dragListClone = _.cloneDeep(this.dragList);
      }
    },
    // 卡片列表 总的
    async getCardList() {
      const resultAll = await Api.cardList();
      const { data: cardListAll = [] } = resultAll;
      if (resultAll.code === '200') {
        const { data = [] } = resultAll;
        // console.log(data, this.dragListBase, '算得上是多');
        data.forEach((item) => {
          this.dragListBase.forEach((iten) => {
            if (item.cardName === iten.cardName) {
              item.component = iten.component;
            }
          });
        });
        this.dragSetList = [...data];
        console.log(this.dragSetList, 'this.dragSetListthis.dragSetList');
      }
    },
    setCardChange(val) {
      this.dragList = this.dragSetList.filter((item) =>
        this.dragListCheck.includes(item.cardCode)
      );
      console.log(this.dragList, 'change this.dragList');
    },
    setShade() {
      this.timer = setInterval(() => {
        this.shadeTime--;
        if (this.shadeTime <= 0) {
          this.isShadeShow = false;
          clearInterval(this.timer);
          this.shadeTime = 4;
        }
      }, 1000);
    },
    handleIKnow() {
      clearInterval(this.timer);
      this.isShadeShow = false;
    },
    layoutSet() {
      this.isLayoutSet = false;
      this.drawer = false;
      /* this.isShadeShow = true;
      const body = document.querySelector('body');
      const shade = this.$refs.shade;
      this.$nextTick(() => {
        if (body.append) {
          body.append(shade);
        } else {
          body.appendChild(shade);
        }
      });
      this.setShade(); */

      if (!localStorage.getItem('isShadeShowLocal')) {
        // 动画
        this.isShadeShow = true;
        localStorage.setItem('isShadeShowLocal', false);
        const body = document.querySelector('body');
        const { shade } = this.$refs;
        this.$nextTick(() => {
          if (body.append) {
            body.append(shade);
          } else {
            body.appendChild(shade);
          }
        });
        this.setShade();
      }
    },
    cancelHandle() {
      this.isLayoutSet = true;
      this.drawer = false;
      this.dragList = [...this.dragListClone];
      this.dragListCheck = [];
      this.dragList.forEach((item) => {
        this.dragListCheck.push(item.cardCode);
      });
    },
    async saveHandle() {
      const result = await Api.saveCardList(this.dragList);
      if (result.code === '200') {
        this.getUserCardList();
        this.isLayoutSet = true;
        this.drawer = false;
      } else {
        this.$message.warning('抱歉，保存失败，请稍后重试');
        this.cancelHandle();
      }
    },
    handleClose(done) {
      done();
      this.cancelHandle();
    },

    showTips() {
      const driver = new Driver({
        padding: 0,
        doneBtnText: '关闭',
        closeBtnText: '不在提醒',
        nextBtnText: '下一步',
        prevBtnText: '上一步',
      });
      // Define the steps for introduction
      driver.defineSteps([
        {
          element: '.first-element-introduction',
          popover: {
            title: '采购中心',
            description: '您可在此管理您的采购业务',
            position: 'left-center',
          },
        },
        {
          element: '.second-element-introduction',
          popover: {
            title: '查看更多',
            description: '您可在此查看更多信息',
            position: 'left-center',
          },
        },
      ]);
      // Start the introduction
      driver.start();
    },
  },
};
</script>

<style lang="scss" scoped>
.shade-black {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  z-index: 10000;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  .an-content {
    background: url('~@/assets/img/home/workbench/fixed.png') no-repeat center
      center;
    background-size: 350px 300px;
    width: 350px;
    height: 300px;
    display: flex;
    align-items: center;
    justify-content: center;
    .an-center {
      width: 350px;
      height: 180px;
      margin-top: 48px;
      background: url('~@/assets/img/home/workbench/move1.png') no-repeat center
        center;
      animation: BX_AniKey1 3.04s steps(1) 0s infinite normal none;
    }
  }
  .message {
    margin: 10px 0 20px 0;
    color: var(--w-0-ffffff, #fff);
    text-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.25);
    /* 五级文字/加粗/20px/行高20px */
    font-family: Source Han Sans CN;
    font-size: 20px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
    text-align: center;
  }
  .an-btn {
    display: flex;
    justify-content: center;
    position: relative;
    .an-time {
      position: absolute;
      top: 6px;
      left: 225px;
      font-size: 12px;
      color: #fff;
    }
  }
}
@keyframes BX_AniKey1 {
  0.00% {
    transform: translate3D(0px, 0px, 0px) rotate(0deg) scale(1, 1);
  }
  1.37% {
    transform: translate3D(0px, -1.82px, 0px) rotate(0deg) scale(1, 1);
  }
  2.74% {
    transform: translate3D(0px, -4.05px, 0px) rotate(0deg) scale(1, 1);
  }
  4.11% {
    transform: translate3D(0px, -5.94px, 0px) rotate(0deg) scale(1, 1);
  }
  5.48% {
    transform: translate3D(0px, -7.39px, 0px) rotate(0deg) scale(1, 1);
  }
  6.85% {
    transform: translate3D(0px, -8.44px, 0px) rotate(0deg) scale(1, 1);
  }
  8.22% {
    transform: translate3D(0px, -9.18px, 0px) rotate(0deg) scale(1, 1);
  }
  9.59% {
    transform: translate3D(0px, -9.66px, 0px) rotate(0deg) scale(1, 1);
  }
  10.96% {
    transform: translate3D(0px, -9.92px, 0px) rotate(0deg) scale(1, 1);
  }
  12.33% {
    transform: translate3D(0px, -10px, 0px) rotate(0deg) scale(1, 1);
  }
  13.70% {
    transform: translate3D(0px, -9.82px, 0px) rotate(0deg) scale(1, 1);
  }
  15.07% {
    transform: translate3D(0px, -9.3px, 0px) rotate(0deg) scale(1, 1);
  }
  16.44% {
    transform: translate3D(0px, -8.49px, 0px) rotate(0deg) scale(1, 1);
  }
  17.81% {
    transform: translate3D(0px, -7.43px, 0px) rotate(0deg) scale(1, 1);
  }
  19.18% {
    transform: translate3D(0px, -6.16px, 0px) rotate(0deg) scale(1, 1);
  }
  20.55% {
    transform: translate3D(0px, -4.72px, 0px) rotate(0deg) scale(1, 1);
  }
  21.92% {
    transform: translate3D(0px, -3.16px, 0px) rotate(0deg) scale(1, 1);
  }
  23.29% {
    transform: translate3D(0px, -1.52px, 0px) rotate(0deg) scale(1, 1);
  }
  24.66% {
    transform: translate3D(0px, 0.15px, 0px) rotate(0deg) scale(1, 1);
  }
  26.03% {
    transform: translate3D(0px, 1.83px, 0px) rotate(0deg) scale(1, 1);
  }
  27.40% {
    transform: translate3D(0px, 3.46px, 0px) rotate(0deg) scale(1, 1);
  }
  28.77% {
    transform: translate3D(0px, 5px, 0px) rotate(0deg) scale(1, 1);
  }
  30.14% {
    transform: translate3D(0px, 6.41px, 0px) rotate(0deg) scale(1, 1);
  }
  31.51% {
    transform: translate3D(0px, 7.64px, 0px) rotate(0deg) scale(1, 1);
  }
  32.88% {
    transform: translate3D(0px, 8.66px, 0px) rotate(0deg) scale(1, 1);
  }
  34.25% {
    transform: translate3D(0px, 9.42px, 0px) rotate(0deg) scale(1, 1);
  }
  35.62% {
    transform: translate3D(0px, 9.88px, 0px) rotate(0deg) scale(1, 1);
  }
  36.99% {
    transform: translate3D(0px, 9.99px, 0px) rotate(0deg) scale(1, 1);
  }
  38.36% {
    transform: translate3D(0px, 9.75px, 0px) rotate(0deg) scale(1, 1);
  }
  39.73% {
    transform: translate3D(0px, 9.18px, 0px) rotate(0deg) scale(1, 1);
  }
  41.10% {
    transform: translate3D(0px, 8.32px, 0px) rotate(0deg) scale(1, 1);
  }
  42.47% {
    transform: translate3D(0px, 7.23px, 0px) rotate(0deg) scale(1, 1);
  }
  43.84% {
    transform: translate3D(0px, 5.93px, 0px) rotate(0deg) scale(1, 1);
  }
  45.21% {
    transform: translate3D(0px, 4.48px, 0px) rotate(0deg) scale(1, 1);
  }
  46.58% {
    transform: translate3D(0px, 2.91px, 0px) rotate(0deg) scale(1, 1);
  }
  47.95% {
    transform: translate3D(0px, 1.26px, 0px) rotate(0deg) scale(1, 1);
  }
  49.32% {
    transform: translate3D(0px, -0.41px, 0px) rotate(0deg) scale(1, 1);
  }
  50.68% {
    transform: translate3D(0px, -2.07px, 0px) rotate(0deg) scale(1, 1);
  }
  52.05% {
    transform: translate3D(0px, -3.69px, 0px) rotate(0deg) scale(1, 1);
  }
  53.42% {
    transform: translate3D(0px, -5.21px, 0px) rotate(0deg) scale(1, 1);
  }
  54.79% {
    transform: translate3D(0px, -6.59px, 0px) rotate(0deg) scale(1, 1);
  }
  56.16% {
    transform: translate3D(0px, -7.79px, 0px) rotate(0deg) scale(1, 1);
  }
  57.53% {
    transform: translate3D(0px, -8.77px, 0px) rotate(0deg) scale(1, 1);
  }
  58.90% {
    transform: translate3D(0px, -9.49px, 0px) rotate(0deg) scale(1, 1);
  }
  60.27% {
    transform: translate3D(0px, -9.91px, 0px) rotate(0deg) scale(1, 1);
  }
  61.64% {
    transform: translate3D(0px, -9.98px, 0px) rotate(0deg) scale(1, 1);
  }
  63.01% {
    transform: translate3D(0px, -9.68px, 0px) rotate(0deg) scale(1, 1);
  }
  64.38% {
    transform: translate3D(0px, -9.04px, 0px) rotate(0deg) scale(1, 1);
  }
  65.75% {
    transform: translate3D(0px, -8.11px, 0px) rotate(0deg) scale(1, 1);
  }
  67.12% {
    transform: translate3D(0px, -6.93px, 0px) rotate(0deg) scale(1, 1);
  }
  68.49% {
    transform: translate3D(0px, -5.54px, 0px) rotate(0deg) scale(1, 1);
  }
  69.86% {
    transform: translate3D(0px, -4px, 0px) rotate(0deg) scale(1, 1);
  }
  71.23% {
    transform: translate3D(0px, -2.34px, 0px) rotate(0deg) scale(1, 1);
  }
  72.60% {
    transform: translate3D(0px, -0.61px, 0px) rotate(0deg) scale(1, 1);
  }
  73.97% {
    transform: translate3D(0px, 1.15px, 0px) rotate(0deg) scale(1, 1);
  }
  75.34% {
    transform: translate3D(0px, 2.89px, 0px) rotate(0deg) scale(1, 1);
  }
  76.71% {
    transform: translate3D(0px, 4.57px, 0px) rotate(0deg) scale(1, 1);
  }
  78.08% {
    transform: translate3D(0px, 6.15px, 0px) rotate(0deg) scale(1, 1);
  }
  79.45% {
    transform: translate3D(0px, 7.58px, 0px) rotate(0deg) scale(1, 1);
  }
  80.82% {
    transform: translate3D(0px, 8.82px, 0px) rotate(0deg) scale(1, 1);
  }
  82.19% {
    transform: translate3D(0px, 9.82px, 0px) rotate(0deg) scale(1, 1);
  }
  83.56% {
    transform: translate3D(0px, 10.54px, 0px) rotate(0deg) scale(1, 1);
  }
  84.93% {
    transform: translate3D(0px, 10.94px, 0px) rotate(0deg) scale(1, 1);
  }
  86.30% {
    transform: translate3D(0px, 10.98px, 0px) rotate(0deg) scale(1, 1);
  }
  87.67% {
    transform: translate3D(0px, 10.81px, 0px) rotate(0deg) scale(1, 1);
  }
  89.04% {
    transform: translate3D(0px, 10.42px, 0px) rotate(0deg) scale(1, 1);
  }
  90.41% {
    transform: translate3D(0px, 9.77px, 0px) rotate(0deg) scale(1, 1);
  }
  91.78% {
    transform: translate3D(0px, 8.8px, 0px) rotate(0deg) scale(1, 1);
  }
  93.15% {
    transform: translate3D(0px, 7.44px, 0px) rotate(0deg) scale(1, 1);
  }
  94.52% {
    transform: translate3D(0px, 5.62px, 0px) rotate(0deg) scale(1, 1);
  }
  95.89% {
    transform: translate3D(0px, 3.31px, 0px) rotate(0deg) scale(1, 1);
  }
  97.26% {
    transform: translate3D(0px, 0.87px, 0px) rotate(0deg) scale(1, 1);
  }
  98.63% {
    transform: translate3D(0px, 0px, 0px) rotate(0deg) scale(1, 1);
  }
  100.00% {
    transform: translate3D(0px, 0px, 0px) rotate(0deg) scale(1, 1);
  }
}
.el-drawer {
  width: 309px !important;
}
.el-drawer__body {
  display: flex;
  flex-direction: column;
}
.el-drawer__header {
  margin-bottom: 0;
  padding: 0 20px;
  height: 44px;
  display: flex;
  background: #f5f5f5;
  color: #333;
}
.el-drawer__body .cord-content-work {
  padding: 10px;
  flex: 1;
  .el-checkbox__inner::after {
  }
  .el-checkbox__inner {
    width: 16px;
    height: 16px;
    border-radius: 0;
    &::after {
      top: 2px;
      left: 5px;
    }
  }
  .el-checkbox__input.is-checked + .el-checkbox__label {
    color: #333;
    font-size: 14px;
  }
}
.el-drawer__body .cord-content-work .el-checkbox-group {
  display: flex;
  flex-direction: column;
}
.el-drawer__body .cord-content-work .el-checkbox-group .el-checkbox {
  margin: 10px;
  display: flex;
  justify-content: space-between;
  flex-direction: row-reverse;
}
.el-drawer__body .btn-content {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 20px;
  .btn {
    padding: 0;
    min-width: 64px;
    height: 30px;
    font-size: 14px;
    font-weight: normal;
  }
  .submit-btn {
    background: #2587ff;
    color: #fff;
    border: none;
  }
  .cancel-btn {
    color: #2587ff;
    border: 1px solid #2587ff;
  }
}
</style>

<style lang="scss" scoped>
@import '@/assets/css/theme.scss';
.workbench {
  width: 100%;
  .set-wrap {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .left {
      display: flex;
      align-items: center;
      font-size: 24px;
      font-weight: bold;
      .text {
        margin-left: 10px;
      }
      /* .icon {
        height: 24px;
        width: 24px;
        margin-right: 10px;
      } */
    }
    .right {
      .set-btn {
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 12px;
        height: 24px;
        width: 80px;
        border: 1px solid #2587ff;
        color: #2587ff;
        cursor: pointer;
        background: #fff;
        &:hover {
          background: #e8efff;
        }
      }
      .set-content {
        display: flex;
        align-items: center;
        .text {
          color: #333333;
          font-size: 16px;
        }
        & div {
          margin-right: 10px;
        }
        .card-set {
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 12px;
          height: 24px;
          padding: 0 10px;
          border: 1px solid #2587ff;
          color: #2587ff;
          background: #fff;
          cursor: pointer;
          .el-icon-arrow-down {
            padding-left: 10px;
          }
          &:hover {
            background: #e8efff;
          }
        }
        .cancel {
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 12px;
          min-width: 60px;
          height: 24px;
          padding: 0 10px;
          border: 1px solid #2587ff;
          color: #2587ff;
          cursor: pointer;
          background: #fff;
          &:hover {
            background: #e8efff;
          }
        }
        .save {
          display: flex;
          justify-content: center;
          align-items: center;
          min-width: 60px;
          font-size: 12px;
          height: 24px;
          padding: 0 10px;
          background: #2587ff;
          color: #fff;
          cursor: pointer;
          &:hover {
            background: #126edf;
          }
        }
      }
    }
  }
  .taskbar {
    border: 1px solid #dcdcdc;
    .taskbar_header {
      height: 44px;
      background: #f5f5f5;
      justify-content: space-between;
      align-items: center;
      padding: 0 20px;
      img {
        cursor: pointer;
      }
    }
    .task_menu {
      padding: 20px;
      .task_icon {
        width: 54px;
        height: 54px;
        background: #f5f5f5;
        line-height: 54px;
        text-align: center;
        border-radius: 50%;

        img {
          vertical-align: middle;
        }
      }
      .task_item {
        display: flex;
        flex-flow: column;
        align-items: center;
        cursor: pointer;
        margin-right: 20px;
        p {
          font-size: 14px;
          color: #333333;
          margin-top: 10px;
        }
        p:hover {
          color: $main-col;
        }
      }
    }
    .task_data {
      padding: 20px;
      width: 1008px;
      .task_title {
        font-size: 14px;
        line-height: 14px;
        font-weight: 600;
        color: #333333;
        margin-bottom: 20px;
      }
      .data_item {
        position: relative;
        margin-right: 44px;
      }
      .item_end {
        margin-right: 0px;
      }
      .item_end:after {
        display: none;
      }
      .data_item:after {
        content: '';
        display: inline-block;
        width: 1px;
        background: #dcdcdc;
        height: 100%;
        position: absolute;
        top: 0;
        right: -22px;
      }
      .task_data_item {
        position: relative;
        margin-right: 44px;
        min-width: 110px;
        .task_desc {
          margin-bottom: 20px;
          color: #333333;
          font-size: 14px;
          line-height: 14px;

          text-align: left;
        }
        .task_list {
          margin-bottom: 20px;
          color: #666666;
          font-size: 14px;
          line-height: 14px;
          .name {
            display: inline-block;
            width: 105px;
            text-align: right;
          }
          .count {
            color: $main-col;
            font-weight: 600;
            margin-left: 5px;
            cursor: pointer;
            width: 22px;
            display: inline-block;
          }
          .count:hover {
            border-bottom: 1px solid $main-col;
          }
          .count_none {
            font-weight: 600;
            margin-left: 5px;
            width: 22px;
            display: inline-block;
          }
        }
      }
      .task_data_item_box:after {
        content: '';
        display: inline-block;
        width: 1px;
        background: #dcdcdc;
        height: 100%;
        position: absolute;
        top: 0;
        right: -22px;
      }
      .task_data_item_end {
        margin-right: 0px;
      }
    }
  }
}

.popover_title {
  padding: 0 20px;
  height: 30px;
  line-height: 30px;
  background: #f5f5f5;
  color: #333333;
  font-size: 14px;
}
.checkList {
  display: flex;
  padding: 20px 20px 0 20px;
  flex-wrap: wrap;
  .checkList_item {
    flex: 0 0 50%;
    margin-bottom: 20px;
  }
}
</style>
